import { useNavigate } from "react-router-dom";
import logoImage from "../../assets/logo.svg";
import TermsContent from "../../components/legal/TermsContent";
import Button from "../../components/ui/Button/Button";
import Header from "../../components/ui/Header/Header";
import { companyName } from "../../constants/constants";

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-myteengig-background">
      <Header
        sticky
        brand={
          <button
            type="button"
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-3 text-left"
            aria-label={`${companyName} home`}
          >
            <img src={logoImage} alt={`${companyName} logo`} className="h-14 w-14 shrink-0 sm:h-16 sm:w-16" />
            <span className="hidden text-2xl font-bold text-myteengig-text-primary md:inline">{companyName}</span>
          </button>
        }
        rightSlot={
          <>
            <Button variant="primary" size="sm" className="h-8 min-w-[74px] px-2.5 text-xs justify-center whitespace-nowrap" onClick={() => navigate("/signup")}>
              Sign up
            </Button>
            <Button variant="outline" size="sm" className="h-8 min-w-[74px] px-2.5 text-xs justify-center whitespace-nowrap" onClick={() => navigate("/login")}>
              Log in
            </Button>
          </>
        }
        mobileMenuEnabled={false}
        containerClassName="py-4"
        className="backdrop-blur supports-[backdrop-filter]:bg-myteengig-surface/90"
      />

      <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-12">
        <div className="mb-4">
          <Button variant="tertiary" size="sm" className="px-0 shadow-none" onClick={() => navigate("/")}>
            Back to home
          </Button>
        </div>
        <section className="rounded-xl border border-myteengig-border bg-white p-4 shadow-sm sm:p-6">
          <h1 className="mb-5 text-3xl font-bold text-myteengig-text-primary">Terms of Service</h1>
          <TermsContent />
        </section>
      </main>
    </div>
  );
};

export default TermsPage;
